// Text size of this device (design 01a 9, "글자 크기"): the root font size,
// which every rem in styles.css follows. Kept per browser like the other
// view preferences, so a grandparent's phone can read larger than the PC.
import { readPref, writePref } from './prefs'

const KEY = 'hm.font-size'

export const FONT_SIZES = [
  { value: 'small', label: '작게', px: 14 },
  { value: 'normal', label: '보통', px: 16 },
  { value: 'large', label: '크게', px: 18 },
  { value: 'xlarge', label: '아주 크게', px: 20 },
] as const

export type FontSize = (typeof FONT_SIZES)[number]['value']

const VALUES = FONT_SIZES.map((f) => f.value)

export function fontSize(): FontSize {
  return readPref<FontSize>(KEY, VALUES, 'normal')
}

/** Sets the size now (and remembers it when save is true). */
export function applyFontSize(size: FontSize, save = false): void {
  const px = FONT_SIZES.find((f) => f.value === size)?.px ?? 16
  document.documentElement.style.fontSize = px === 16 ? '' : `${px}px`
  if (save) writePref(KEY, size)
}
